import React from 'react'
// import ProgramFlowItem from './ProgramFlowItem'
import GetCertified from './GetCertified'

function ProgramFlow() {
    return (
        <div className="content-section">
            <div className="content-left-container">
                <div className="content-left">
                    <div>
                        <h1>Unlock your next adventure</h1>
                        <div className="cta-container">
                            <div className="cta-btn px-5">
                                Register Now 
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content-right-container">
                {/* <div className="content-right">
                    <h2 className="mb-5">Program Flow</h2>

                    <ProgramFlowItem title="Introduction and Ice-Breaking" subtitle="30 minutes" img="/img/icons/introduction.png" colorClass="color1"/>

                    <ProgramFlowItem title="Know your Skill Quotient" subtitle="30 minutes" img="/img/icons/skill-quotient.png" colorClass="color2"/>
                    
                    <ProgramFlowItem title="Activity Session: Solve a Problem" subtitle="60 minutes" img="/img/icons/problem-solving.png" colorClass="color3"/>
                    
                    <ProgramFlowItem title="Pitch your Ideas" subtitle="30 minutes" img="/img/icons/pitching.png" colorClass="color4"/>

                    <ProgramFlowItem title="Academix Master Class" subtitle="60 minutes" img="/img/icons/design-thinking.png" colorClass="color5"/>
                
                </div> */}
                <GetCertified />
            </div>
        </div>
    )
}

export default ProgramFlow
